import {
  makePaginationState,
  STATUSES,
  concatUnique,
} from 'app/utils/redux';

import * as t from './types';


const initialState = {
  users: makePaginationState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch users
    case `${t.FETCH_USERS}_PENDING`:
      return {
        ...state,
        users: {
          ...state.users,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_USERS}_SUCCESS`:
      return {
        ...state,
        users: {
          sectionId: action.meta.sectionId,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(state.users.pagination.items, action.payload.result.items),
          },
        },
      };
    case `${t.FETCH_USERS}_ERROR`:
      return {
        ...state,
        users: {
          ...state.users,
          status: STATUSES.ERROR,
          isLoaded: false,
        },
      };

    // reset
    case t.RESET:
      return {
        ...state,
        users: makePaginationState(),
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/userList/reducer.js